import 'isomorphic-fetch';
import preprocessResponse from 'ha/utils/preprocessResponse';

interface Car {
  car: {
    rushHour?: boolean;
  };
}

interface Walk {
  walk: {
    speed?: number;
    uphill?: number;
    downhill?: number;
  };
}

interface Bike {
  bike: {
    speed?: number;
    uphill?: number;
    downhill?: number;
  };
}

interface Transit {
  transit: {
    frame?: {
      date?: string;
      time?: number;
      duration?: number;
    };
    maxTransfers?: number;
  };
}

export type TravelModeString = 'car' | 'walk' | 'bike' | 'transit';

export type TravelMode = Car | Walk | Bike | Transit;

interface Source {
  id: string;
  lat: number;
  lng: number;
  tm?: TravelMode;
}

type Serializer = 'json' | 'geojson';
type IntersectionMode = 'union' | 'average' | 'intersection' | 'none';
type EdgeWeight = 'time' | 'distance';

export interface PolygonSpecification {
  srid?: number;
  intersectionMode?: IntersectionMode;
  serializer?: Serializer;
  values: Array<number>;
  simplify?: number;
}

export interface PolygonRequest {
  sources: Array<Source>;
  edgeWeight: EdgeWeight;
  polygon: PolygonSpecification;
}

interface Features {
  id: string;
  type: string;
  properties: {
    area: number;
    time: number;
  };
  geometry: {
    type: string;
    coordinates: number[][][][];
  };
}

export interface PolygonResponse {
  data: {
    features: Features[];
  };
}

export default class LocalyseService {
  private host: string;

  private apiKey: string;

  constructor(host: string, apiKey: string) {
    this.host = host;
    this.apiKey = apiKey;
  }

  // https://docs.targomo.com/#/Isochrone%20API/post_westcentraleurope_v1_polygon
  polygon(request: PolygonRequest): Promise<PolygonResponse> {
    return fetch(
      `${this.host}/westcentraleurope/v1/polygon?key=${this.apiKey}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      },
    ).then(preprocessResponse);
  }
}
